<div class="dialog-content-wrapper admin_modal prsn_dialog common-modal text-center">
        <button mat-icon-button class="close-btn" (click)="dialogRef.close(false)">
                <mat-icon>close</mat-icon>
        </button>
        <div class="modal_section">
                <h1 class="text-success mb-3" matDialogTitle *ngIf="dialogAction == 'success'">
                        <mat-icon>check_circle</mat-icon> Success!
                </h1>
                <h1 class="text-danger" matDialogTitle *ngIf="dialogAction == 'delete' || dialogAction == 'Alert'">
                        <mat-icon>error_outline</mat-icon> Alert!
                </h1>
        </div>

        <div mat-dialog-content>
                <span *ngIf="statusText" [innerHTML]="statusText"></span>
        </div>
        <div mat-dialog-actions class="justify-content-center">
                <button mat-flat-button class="btn mat-accent mr-16" color="primary" *ngIf="dialogAction == 'success'"
                        (click)="dialogRef.close(true)">Continue</button>
                <button mat-flat-button class="btn mat-accent mr-16" color="primary" *ngIf="dialogAction == 'delete'"
                        (click)="dialogRef.close(true)">Confirm</button>
                <button class="btn-cancel btn" mat-flat-button *ngIf="dialogAction == 'delete'"
                        (click)="dialogRef.close(false)">Cancel</button>
                <button mat-flat-button class="btn mat-accent mr-16" color="primary" *ngIf="dialogAction == 'Alert'"
                        (click)="dialogRef.close(true)">Ok</button>
        </div>
</div>